import { useEffect, useState } from "react";
import { apiURL, GetAnyList } from "../../WmUtils";
import useVersionStore from "../../../stores/versionStore";
import useDevMenuStore from "../../../stores/DevMenuStore";

const serverVersionURL = apiURL + "/server-version/";

const Versioning = () => {
  const { mobileVersion, serverVersion, serverVersionFetchFailed, setServerVersion, setServerVersionFetchFailed } =
    useVersionStore();
  const { setDevMenu } = useDevMenuStore();
  // Handle fetching the server version and comparing it
  // with the mobile version to show update notification.
  // Note: GetAnyList never rejects on a network error/timeout - it catches
  // the axios error internally and resolves with `err.response`, which is
  // undefined when no response was ever received. So a failed fetch (no
  // connection, timeout) must be detected from the resolved value, not
  // only from the .catch branch below (kept as a defensive fallback).
  useEffect(() => {
    setServerVersionFetchFailed(false);
    GetAnyList(serverVersionURL)
      .then((response) => {
        const version = response?.data?.version;
        if (version) {
          setServerVersion(version);
        } else {
          console.error("Nem sikerült letölteni a szerver verzióját: érvénytelen válasz", { response });
          setServerVersionFetchFailed(true);
        }
      })
      .catch((error) => {
        console.error("Hiba a verzió lekérdezésnél: ", { cause: error });
        setServerVersionFetchFailed(true);
      });
  }, []);

  const showUpdateNotification = !serverVersionFetchFailed && serverVersion != mobileVersion;

  const [tapCount, setTapCount] = useState(0);

  // Reset tap count if user stops tapping for 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => setTapCount(0), 2000);
    return () => clearTimeout(timer);
  }, [tapCount]);

  const handleTap = () => {
    const newCount = tapCount + 1;
    if (newCount === 5) {
      setDevMenu(true);
      setTapCount(0);
    } else {
      setTapCount(newCount);
    }
  };

  return (
    <>
      <div
        onClick={handleTap}
        style={{
          MozUserSelect: "none",
          WebkitUserSelect: "none",
          msUserSelect: "none",
        }}
      >
        <div>Mobil verzió: {mobileVersion}</div>
        <div>Szerver verzió: {serverVersion}</div>
        {serverVersionFetchFailed && (
          <div style={{ color: "red" }}>
            {"Nem sikerült letölteni a szerver verzióját."}
          </div>
        )}
        {showUpdateNotification && (
          <div style={{ color: "red" }}>
            {"Új frissítés áll rendelkezésre, kérem telepítse!"}
          </div>
        )}
      </div>
    </>
  );
};

export default Versioning;
